import { CircularProgress } from "@mui/material";
import * as XLSX from 'xlsx';
import { calculateDueDays, getMaintenanceStatus } from ".";

export const isValidDate = (dateString) => {
    const dateObj = new Date(dateString);
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

    const regex = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/;
    return regex.test(formattedDate);
};

export const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export const dataNotAvailableMsg = <div style={{margin:'24px 0 20px 0', fontSize: 16}}>Data not available</div>

export const generateReportMsg = <div className='w3-center' style={{ margin: '44px 0 20px 0', fontSize: 16 }}>Please click on generate report to view the report</div>

export const showCircularProgress = (
    <div className="w3-center" style={{ marginTop: 30 }}>
        <CircularProgress />
    </div>
)

export const isGreenUser = (username) => {
    if (!username) { return }
    const mailDomain = username.trim().split('@').pop();
    return ["greenvironmentindia.com", "greenvironment.in"].includes(mailDomain)

}

export const exportFullAssetTableToExcel = (fullResponseData, tabId, client_id) => {
    const exportData = [];

    const totalAssetCost = fullResponseData.reduce((grandTotal, fItem) => {
      return grandTotal + fItem.assets.reduce((sum, item) => sum + (parseFloat(item.cost) || 0), 0);
    }, 0);
  
    fullResponseData.forEach((fItem, facilityIndex) => {
      const totalCost = fItem.assets.reduce((sum, item) => sum + (parseFloat(item.cost) || 0), 0);
      const slNo = facilityIndex + 1;
  
      fItem.assets.forEach((item, index) => {
        const isFirst = index === 0;
  
        const maintenanceDueDays = calculateDueDays(
          item?.operation_start_date,
          item?.componentSchedule,
          item?.assetMaintenance,
          item?.operation_end_date
        );
  
        const maintenanceStatus = getMaintenanceStatus(
            maintenanceDueDays?.scheduleItem?.offset_time_days ?? null,
            item?.assetMaintenance,
            maintenanceDueDays?.maintenanceCompleted ?? null
        );
  
        const scheduleText = maintenanceDueDays?.overdueDays
        ? `Overdue By ${maintenanceDueDays?.overdueDays} Days`
        : maintenanceDueDays?.dueDays !== null
        ? `In ${maintenanceDueDays?.dueDays} Days`
        : '--';
  
        const scheduleDate = maintenanceDueDays?.actualMaintenanceDate
        ? `(${maintenanceDueDays?.actualMaintenanceDate})`
        : '';
  
        exportData.push({
          "Sl. No.": isFirst ? slNo : '',
          "Facility": isFirst ? item.facility?.facility_name : '',
          "Location": isFirst ? item.facility?.location?.name : '',
          "Item Name": item?.assetName?.asset_name || '--',
          "Serial Number": item.serial_number || '--',
          "Associated Meter": item.assetMeter?.meter?.meterid || '--',
          "Purchase Date": item.purchase_date
            ? new Date(item.purchase_date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
              })
            : '--',
          "Installation Date": item.installation_date
            ? new Date(item.installation_date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
              })
            : '--',
          "Asset Cost": item.cost ? `₹ ${item.cost}` : '--',
          "Particulars": item.particulars || '--',
          ...(tabId === 'distribution' || tabId === 'treatment'
            ? {
                "Component ID": item?.component_id || '--',
                "Rating": item?.rating || '--',
                "Unit Price": item?.unit_price || '--',
                "Operation Start Date": item.operation_start_date
                ? new Date(item.operation_start_date).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })
                : '--',
                "Operation End Date": item.operation_end_date
                ? new Date(item.operation_end_date).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })
                : '--',
                "End Of Life Date": item.end_of_life_date
                ? new Date(item.end_of_life_date).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })
                : '--',
                "Maintenance Schedule": `${scheduleText} ${scheduleDate}`.trim(),
                "Maintenance Status": maintenanceStatus?.status || '--',
              }
            : {}),
            ...(tabId === 'leased-asset'
            ? {
                "Bill Number": item?.bill_number || '--',
                "Vendor Name": item?.vendor_name || '--',
                "Warranty End Date": item.warranty_end_date
                ? new Date(item.warranty_end_date).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })
                : '--',
              }
            : {}),
          ...(isFirst ? { "Total Facility Cost": `₹ ${totalCost.toLocaleString()}` } : { "Total Facility Cost": '' }),
        });
      });
    });

    if ( exportData?.length > 0 ) {
      const finalRow = Object?.fromEntries(
        Object?.keys(exportData[0])?.map((key) => [key, ''])
      );
      finalRow["Total Assets Value"] = `Grand Total: ₹ ${totalAssetCost.toLocaleString()}`;
      exportData.push(finalRow);
    }

    const normalizedCategory = tabId
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('-');
  
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${normalizedCategory}`);
    XLSX.writeFile(workbook, client_id ? `client_assets_${client_id}_export.xlsx` : `assets_export.xlsx`);
}